import { render, staticRenderFns } from "./NavbarBuilderModal.vue?vue&type=template&id=60c7707e"
import script from "./NavbarBuilderModal.vue?vue&type=script&lang=js"
export * from "./NavbarBuilderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports